import Logger from './utils/Logger';
import Pair from './Pair';
import Room from './Room';
import Base64 from './utils/Base64';
import Stream from './Stream';
import version from './../Common.config';
import { EventDispatcher, RoomEvent, StreamEvent, PublisherEvent } from './Events';

import customErrors from './customErrors';
import VcxEventProperties from './vcxEventProperties';

/*
* Breakout room class, takes care of joining breakout room and managing it.
*/
const BreakOutRoom = (parentRoom, specInput) => {
    const spec = specInput;
    const that = EventDispatcher(specInput);
    that.rooms = new Map();
    that.currentBreakOutRoom = null;


    that.joinRoom = (token, streamInfo, callback, reconnectInfo = { allow_reconnect: true, number_of_attempts: 3, timeout_interval: 45000 }) => {
        let room;
        let localStream;
        let error = null;
        let success = null;
        Logger.info('SDK version is: ', version.product.version);

        if (token != null) {
            Logger.info('=========== port of hope');
            const tok = JSON.parse(window.atob(token));
            tok.version = version.product.version;
            Logger.info('Token Received ->>>', JSON.stringify(tok));
            room = Room(undefined, undefined, { token: Base64.encodeBase64(JSON.stringify(tok)), reconnectInfo });
            const onAccessSuccess = () => {
                if (Pair.browserEngineCheck() === 'IE') {
                    streamInfo.video = false;
                    const plugin = document.getElementById('WebrtcEverywherePluginId');
                    plugin.addEventListener('room-connected', (streamEvent) => {
                        that.rooms.set(room.roomID, room); //Room-Connected breakout Room
                        success = {
                            streams: streamEvent.data.streams, room, roomData: streamEvent.data.room, localStream,
                        };
                        room.publish(localStream, (response) => {
                            if (response.result === 0) {
                                success.publishId = response.id;
                                callback(success, null);
                            } else {
                                callback(null, response);
                            }
                        });
                    });
                    plugin.addEventListener('room-error', (err) => {
                        callback(success, err.data);
                    });
                    plugin.addEventListener('stream-added', (streamEvent) => {
                        room.subscribe(streamEvent.data.stream);
                    });
                } else {
                    room.addEventListener('room-connected', (streamEvent) => {
                        //Video not supported as of now.
                        streamInfo.video = false;
                        Logger.info('-----------BreakoutRoom-Connected--------');
                        success = {
                            streams: streamEvent.streams,
                            room,
                            roomData: streamEvent.room,
                            localStream,
                        };
                        callback(success, null);
                        room.publish(localStream, (response) => {
                            if (response.result === 0) {
                                success.publishId = response.id;
                            } else {
                                room.dispatchEvent(RoomEvent({ type: 'room-error', message: response }));
                            }
                        });
                        for (let i = 0; i < success.streams.length; i++) {
                            const optionsInput = {};
                            room.subscribe(success.streams[i], optionsInput, (res) => {
                                // check if all the streams subscribed properly and flag that subscribed streams are fine
                                if (res === true) {
                                    Logger.info('breakout room-subscribe callback success');
                                } else {
                                    Logger.info('breakout room-subscribe callback failed, could not subscribe streams', res);
                                    room.dispatchEvent(RoomEvent({ type: 'room-error', message: res }));
                                    //EL.error('api-event', customEvents.event_reconnect_subscribe_failed,
                                }
                            });
                        }
                        //add the room to breakout room Map.
                        that.rooms.set(room.roomID, room);
                        const connectEvt = RoomEvent({ type: 'breakout-room-connected', success });
                        that.dispatchEvent(connectEvt);
                    });
                    room.addEventListener('room-error', (err) => {
                        callback(null, err);
                    });
                    room.addEventListener('stream-added', (streamEvent) => {
                        room.subscribe(streamEvent.stream);
                    });
                    room.addEventListener('room-disconnected', that.onBreakOutRoomDisconnect.bind(room));
                }
                if (room.reconnectionState === false && room.reconnectAttempt == 0) {
                    Logger.info('-----------BreakoutRoom-Connecting--------');
                    room.connect(reconnectInfo);
                } else {
                    Logger.debug(' Reconnection case in join room public api');
                }
            };
            //Success Cases
            const onAccessError = (err) => {
                error = err;
                callback(success, error);
            };
            //Error cases
            if (streamInfo.audio || streamInfo.video) {
                //streamInfo.video = false //By default breakout will have video disabled.
                localStream = room.initPublishStream(streamInfo.div, streamInfo, onAccessSuccess, onAccessError);
            } else {
                Logger.info(' No publish stream. audio and video are disabled..');
                onAccessSuccess();
            }
        }
        return localStream;
    };

    that.endBreakOutRoom = (room_id) => {
        Logger.info('Breakout Room ended, Disconnecting the room');
        const room = that.rooms.get(room_id);
        room.disconnect();
    };

    that.onBreakOutRoomDisconnect = (room) => {
        const breakout_room_disconnected = RoomEvent({ type: 'breakout-room-disconnect', message: { room_id: room.id } });
        that.rooms.delete(room.roomID);
        that.dispatchEvent(breakout_room_disconnected);
    };

    that.onUserLeft = (room, arg) => {
        const userName = arg.name;
        const userRole = arg.role;
        const userPermissions = arg.permissions;
        const clientId = arg.clientId;
        const evt = UserEvent({
            type: 'user-disconnected',
            room_id: room.roomID,
            name: userName,
            clientId,
            role: userRole,
            permission: userPermissions,
        });
        that.dispatchEvent(evt);
    };

    that.onUserJoined = (room, arg) => {
        const userName = arg.name;
        const userRole = arg.role;
        const userPermissions = arg.permissions;
        const user = {
            name: arg.name,
            permissions: arg.permissions,
            role: arg.role,
            user_ref: arg.user_ref,
            videoMuted: arg.videoMuted,
            audioMuted: arg.audioMuted,
        };
        that.userList.set(arg.clientId, user);
        const evt = UserEvent({
            type: 'user-connected', name: userName, clientId: arg.clientId, role: userRole, permission: userPermissions, user,
        });
        that.dispatchEvent(evt);
    };

    that.disconnectAll = () => {
        that.rooms.forEach((room, room_id) => {
            if (room) room.disconnect();
        });
    };
    return that;
};

export default BreakOutRoom;



//////////////////
// WEBPACK FOOTER
// ./src/BreakOutRoom.js
// module id = 188
// module chunks = 0